import type { NdtPrefetchPhase } from './useWeldDrillDownPrefetch';

/** Progress copy for Apply-time NDT waves (out-of-limit first, then remainder). */
export function formatNdtPrefetchProgress(args: {
  phase: NdtPrefetchPhase;
  phaseLoadedCount: number;
  phaseTargetCount: number;
  /** Fallback when phase metadata is unavailable (local host batch). */
  loadedCount?: number;
  totalCount?: number;
}): string {
  const {
    phase,
    phaseLoadedCount,
    phaseTargetCount,
    loadedCount = phaseLoadedCount,
    totalCount = phaseTargetCount,
  } = args;

  if (phase === 'out_of_limit' && phaseTargetCount > 0) {
    return `NDT loaded for ${phaseLoadedCount} of ${phaseTargetCount} out-of-limit welds…`;
  }
  if (phase === 'remaining' && phaseTargetCount > 0) {
    return `NDT loaded for ${phaseLoadedCount} of ${phaseTargetCount} remaining welds…`;
  }
  if (totalCount > 0) {
    return `NDT loaded for ${loadedCount} of ${totalCount} welds…`;
  }
  return 'Loading NDT summaries…';
}
